import Spf from './spf';
import Ptc from './ptc';
import Fai from './fai';

export default class EmploymentInfo {
  constructor() {
    this.employmentStatus = true;
    this.employerName = true;
    this.occupation = true;
    this.incomeSource = true;
    this.address = true;
    this.spf = new Spf();
    this.ptc = new Ptc();
    this.fai = new Fai();
  }

  loadData(payload) {
    if (payload.Personal_Info) {
      this.employmentStatus = payload.Personal_Info.Employment_Status;
      this.employerName = payload.Personal_Info.Employer_Name;
      this.occupation = payload.Personal_Info.Occupation;
      this.incomeSource = payload.Personal_Info.Source_Of_Income;
    }

    this.spf.loadData(payload);
    this.ptc.loadData(payload);
    this.fai.loadData(payload);
  }
}
